/*
Auto-generated by: https://github.com/pmndrs/gltfjsx
Command: npx gltfjsx@6.5.3 public/WoodenCalender.glb 
*/

import React, { useEffect, useRef } from 'react'
import { shaderMaterial, useGLTF, useTexture } from '@react-three/drei'
import { extend, useFrame } from '@react-three/fiber';
import * as THREE from 'three'

const FrameMaterial = shaderMaterial(
  {
    uTexture: new THREE.Texture(),
    utextureSize: new THREE.Vector2(1,1),
  },
  `
    varying vec2 vUv;
    void main() {
      vUv = uv;
      gl_Position = projectionMatrix * modelViewMatrix * vec4(position, 1.0);
    }
  `,
  `
uniform sampler2D uTexture;
uniform vec2 utextureSize;

varying vec2 vUv;

void main() {
    gl_FragColor = texture2D(uTexture, vUv);
}

  `
);
extend({ FrameMaterial });

export function WoodenCalender({ image = '/image2.jpg', frameSize={width:2,height:1}, FrameColor = "red", Tablecolor = 'white', PotColor = 'white', PlantBcolor = 'white', color = 'white', ...props }) {
  const { nodes, materials } = useGLTF('/3d/WoodenCalender.glb')
  const texture = useTexture(image)
  const diffuse = useTexture('/3d/diffuse2.jpg')
 // diffuse.wrapS == diffuse.wrapT == THREE.RepeatWrapping;
  const materialRef = useRef();
  const container = useRef(null);

    const [aspectX, aspectY] = [frameSize.width, frameSize.height];
  const baseSize = 2;
  const scaleX = (aspectX / Math.max(aspectX, aspectY)) * baseSize;
  const scaleY = (aspectY / Math.max(aspectX, aspectY)) * baseSize;
  const yPosition = -scaleY + 1.0;

  useEffect(() => {
    if (materialRef.current) {
      materialRef.current.uniforms.uTexture.value = texture;
      materialRef.current.uniforms.utextureSize.value.set(1,1);
    }

  }, [texture]);

  useFrame(() => {
    if (container.current) {
      container.current.rotation.y += 0.0015;
    }
  })


  return (
    <group ref={container} receiveShadow castShadow {...props} dispose={null} position={[0, -0.6, 0]} rotation={[0, -Math.PI / 2, 0]}>
      <mesh receiveShadow castShadow geometry={nodes.Table001.geometry}
        material={nodes.Table001.material}
        position={[-0.003, 0.06, 0.002]}
        rotation={[-Math.PI / 2, 0, 0]}
        scale={[0.9, 0.9, 0.9]}
      >
        <meshStandardMaterial color={Tablecolor} side={THREE.DoubleSide} />
      </mesh>
      <group receiveShadow castShadow scale={[1.0, scaleY, scaleX]} position={[0, yPosition, 0]}>
        <group position={[0, -0.02, 0]}>
          <mesh receiveShadow castShadow geometry={nodes.Cube.geometry} material={nodes.Cube.material} position={[-0.019, 1.212, 0.02]} rotation={[-Math.PI / 2, 1.383, Math.PI / 2]} scale={[0.164, 0.164, 0.264]} >
            <meshBasicMaterial
              color={FrameColor}
              map={diffuse}
              side={THREE.DoubleSide} />
          </mesh>
          <mesh receiveShadow castShadow geometry={nodes.Plane.geometry} material={nodes.Plane.material} position={[-0.021, 1.225, 0.02]} rotation={[Math.PI / 2, Math.PI + 0.188, -Math.PI / 2]} scale={0.164} >
            <frameMaterial ref={materialRef} key={FrameMaterial.key} side={THREE.DoubleSide} />
          </mesh>
          <mesh receiveShadow castShadow geometry={nodes.Cube001.geometry} material={nodes.Cube001.material} position={[0.05, 1.0425, 0.02]} rotation={[-Math.PI / 2, 1.383, -Math.PI / 2]} scale={[-0.14, -0.002, -0.018]} >
            <meshBasicMaterial
              color={FrameColor}
              map={diffuse}
              side={THREE.DoubleSide} />
          </mesh>
        </group>
      </group>
      <group receiveShadow castShadow position={[0.125, -0.03, 0.15]}>
        <mesh receiveShadow castShadow geometry={nodes.Cylinder006_Flowerpot5_0001.geometry} material={nodes.Cylinder006_Flowerpot5_0001.material} position={[0.078, 1.077, 0.453]} rotation={[-Math.PI / 2, 0, 0]} >
          <meshBasicMaterial color={PlantBcolor} />
        </mesh>
        <mesh receiveShadow castShadow geometry={nodes.Plane081_Haworthia_leaf_0001.geometry} material={materials['Haworthia_leaf.001']} position={[0.113, 1.162, 0.458]} />
      </group>
      <group position={[0.125, -0.03, -0.15]}>
        <mesh receiveShadow castShadow geometry={nodes.Object_4001.geometry} material={materials['Material.019']} position={[0, 1.008, -0.386]} scale={0.168} >
          <meshBasicMaterial color={PotColor} />
        </mesh>
        <mesh receiveShadow castShadow geometry={nodes.Object_5.geometry} material={materials['Material.020']} position={[0, 1.008, -0.386]} scale={0.168} >
          <meshBasicMaterial color={PotColor} />
        </mesh>
        <mesh receiveShadow castShadow geometry={nodes.Cube_Metal_0.geometry} material={materials['Metal.001']} position={[-0.044, 1.287, -0.403]} rotation={[-Math.PI / 2, 0, 0]} scale={[0.009, 0.013, 0.002]} />
        <mesh receiveShadow castShadow geometry={nodes.Cylinder_BlackMetal_0.geometry} material={materials['BlackMetal.001']} position={[-0.055, 1.163, -0.395]} rotation={[-Math.PI / 2, 0, 0]} scale={0.172} />
        <mesh receiveShadow castShadow geometry={nodes.Cylinder_Metal_0.geometry} material={materials['Metal.001']} position={[-0.055, 1.163, -0.395]} rotation={[-Math.PI / 2, 0, 0]} scale={0.172} />
        <mesh receiveShadow castShadow geometry={nodes.Cylinder001_Material_0.geometry} material={materials['Material.011']} position={[-0.008, 1.144, -0.35]} rotation={[0.279, -0.05, -0.025]} scale={0.001} />
        <mesh receiveShadow castShadow geometry={nodes.Cylinder002_Material002_0.geometry} material={materials['Material.012']} position={[-0.008, 1.148, -0.349]} rotation={[0.279, -0.05, -0.025]} scale={0.001} />
        <mesh receiveShadow castShadow geometry={nodes.Cylinder_Material001_0001.geometry} material={materials['Material.010']} position={[-0.008, 1.144, -0.35]} rotation={[0.279, -0.05, -0.025]} scale={0.001} />
        <group position={[-0.03, -0.02, 0]}>
          <mesh receiveShadow castShadow geometry={nodes.Cylinder001_Material004_0.geometry} material={materials['Material.015']} position={[0.046, 1.283, -0.469]} rotation={[2.77, -0.212, 0.062]} scale={0.0005} />
          <mesh receiveShadow castShadow geometry={nodes.Cylinder002_Material005_0.geometry} material={materials['Material.016']} position={[0.047, 1.295, -0.474]} rotation={[2.77, -0.212, 0.062]} scale={0.00015} />
          <mesh receiveShadow castShadow geometry={nodes.Cylinder003_Material002_0.geometry} material={materials['Material.017']} position={[0.04, 1.185, -0.43]} rotation={[2.77, -0.212, 0.062]} scale={0.0005} />
          <mesh receiveShadow castShadow geometry={nodes.Cylinder_Material001_0002.geometry} material={materials['Material.014']} position={[0.04, 1.185, -0.43]} rotation={[2.77, -0.212, 0.062]} scale={0.0005} />
        </group>
      </group>
    </group>
  )
}

useGLTF.preload('/3d/WoodenCalender.glb')
